<script>
import {mapMutations, mapState} from "vuex";
import ScholarshipCompetitionApi from "../../../scholarship/Services/Api/ScholarshipCompetitionApi";

export default {
  name: "TheTabsTitleProfile",

  mounted() {
    this.getSetting();
  },


  computed: {
    ...mapState({
      current_item: state => state.achievement.current_item_tab,
    }),

  },

  data() {
    return {
      list_tabs: [
        {
          name: 'Общие сведения',
          icon: 'fa fa-user',
          text: 'text-caption',
          tab: 'GeneralInformation',
          visible: true,
        },
        {
          name: 'Заявление ПГАС',
          icon: 'fa-id-card',
          text: 'text-caption',
          tab: 'PGAS',
          visible: false,
        },
        {
          name: 'Портфолио достижений',
          icon: 'fa fa-briefcase',
          text: 'text-caption',
          tab: 'AchievementPortfolio',
          visible: true,
        },
        {
          name: 'Портфолио документов',
          icon: 'fa fa-archive',
          text: 'text-caption',
          tab: 'PortfolioDocuments',
          visible: true,
        },
        {
          name: 'Рейтинг',
          icon: 'fa fa-trophy',
          text: 'text-caption',
          tab: 'Rating',
          visible: true,
        },
      ],
    };
  },

  methods: {
    ...mapMutations({
      setCurrentItem: 'achievement/setCurrentItemTab',
    }),

    async getSetting() {
      const response = await ScholarshipCompetitionApi.settingStatementStudent()
      if(_.isNil(response)) return;

      const statementTab = _.find(this.list_tabs, (o) => o.tab === "PGAS")
      this.$set(statementTab, 'visible', response.data.setting.competition)
    },
  },
}
</script>

<template>
  <v-tabs
    :v-model="current_item"
    :color="$store.state.achievement.side_color"
    icons-and-text
    :right="$vuetify.breakpoint.mdAndUp"
    :centered="$vuetify.breakpoint.mdAndDown"
    :show-arrows="$vuetify.breakpoint.mdAndDown"
    prev-icon="fa fa-chevron-left"
    next-icon="fa fa-chevron-right"
  >
    <v-tab
      v-for="tab in list_tabs"
      :key="tab.tab"
      :class="tab.text"
      v-if="tab.visible"
      @click="setCurrentItem(tab.tab)"
    >
      {{tab.name}}
      <v-icon small>{{tab.icon}}</v-icon>
    </v-tab>
  </v-tabs>
</template>

<style scoped>

</style>